// Follows DRF pagination (`data.next`) to collect every page instead of
// silently truncating at the backend's default PAGE_SIZE.
export async function fetchAllPages(listFn, params = {}) {
  let all = []
  let page = 1
  while (true) {
    const { data } = await listFn({ ...params, page_size: 100, page })
    const results = data.results ?? data
    all = all.concat(results)
    if (!data.next) break
    page++
  }
  return all
}
